<template>
  <Toast />
  <ConfirmDialog group="headless">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
        <div
          class="rounded-full bg-white outline outline-black inline-flex justify-center items-center h-24 w-24 -mt-20">
          <i class="pi pi-question text-5xl"></i>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-6">{{ message.header }}</span>
        <p class="mb-0">{{ message.message }}</p>
        <div class="flex items-center gap-2 mt-6">
          <Button :label="message.rejectLabel" outlined @click="rejectCallback" class="w-32"></Button>
          <Button :label="message.acceptLabel" @click="acceptCallback" class="w-32"></Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>
  <ModalPettyCash v-if="modalShowPettyCash" @closeModal="closeModal" :petty_cash="selectedPettyCash" :current-cash="currentTotalAmountCashRegisterOpen" />
  <IndexView />
  <div id="overlay" class="fixed inset-0 bg-black bg-opacity-30 z-30" :class="{ hidden: !isBlur }"></div>
  <ViewContainer>
    <section class="p-6">
      <PageTitle title="Pengeluaran" />
      <div class="bg-white dark:bg-dark-900 w-full rounded-lg py-6 px-5 shadow-lg shadow-light-100 dark:shadow-dark-500">
        <DetailComponent title="Cash Register" caption="Cash register saat ini" :items="summaryCashRegister"/>
        <div id="table-header" class="mb-5 flex justify-between">
          <AddButton to_url="#" button_text="+ Tambah Pengeluaran" button_class="text-base py-2 font-medium"
            @click="showModal" />
        </div>
        <div class="overflow-x-auto">
          <div class="inline-block min-w-full align-middle">
            <div class="overflow-hidden shadow-lg rounded-lg">
              <TableComponent>
                <TableHead>
                  <TableRow>
                    <TableHeadCell>No</TableHeadCell>
                    <TableHeadCell>Deskripsi</TableHeadCell>
                    <TableHeadCell numeric>Withdraw</TableHeadCell>
                    <TableHeadCell numeric>Deposit</TableHeadCell>
                    <TableHeadCell>Status</TableHeadCell>
                    <TableHeadCell>Dibuat Tanggal</TableHeadCell>
                    <TableHeadCell>Cash Register</TableHeadCell>
                    <!-- <TableHeadCell>Action</TableHeadCell> -->
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow v-if="filteredPettyCashes?.length == 0">
                    <TableCell colspan="5" customClass="text-center italic text-gray-400 dark:text-gray-500"
                      noTextColor>
                      Belum ada data
                    </TableCell>
                  </TableRow>
                  <TableRow v-else v-for="(petty_cash, index) in filteredPettyCashes" :key="petty_cash.id"
                    :index="index" isBody>
                    <TableCell>{{ index + 1 }}</TableCell>
                    <TableCell>{{ petty_cash.description }}</TableCell>
                    <TableCell :rupiah="petty_cash.amount_withdrawal" />
                    <TableCell :rupiah="petty_cash.amount_deposit" />
                    <TableCell>{{ petty_cash.status }}</TableCell>
                    <TableCell>{{ formatTime(petty_cash.createdAt) }}</TableCell>
                    <TableCell>{{ formatTime(petty_cash.cash_register?.time_start) }}</TableCell>
                    <!-- <TableCell noTextColor customClass="text-gray-500 dark:text-gray-400 flex">
                      <button :id="'edit-data-' + petty_cash.id" @click="editExpenditure(expenditure)"
                        class="border border-gray-400 hover:border-green-700 hover:bg-green-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                        <PencilSquareIcon class="h-4 w-4 group-hover:text-green-700" />
                      </button>
                      <button :id="'delete-data-' + petty_cash.id" @click="deleteExpenditure(expenditure)"
                        class="border border-gray-400 hover:border-red-500 hover:bg-red-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                        <TrashIcon class="h-4 w-4 group-hover:text-red-700" />
                      </button>
                    </TableCell> -->
                  </TableRow>
                </TableBody>
              </TableComponent>
              <PaginationButtons v-model="currentPage" :totalPages="totalPages" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </ViewContainer>
</template>

<script>
import IndexView from "@/views/IndexView.vue";
import PageTitle from "@/components/PageTitle.vue";
import AddButton from "@/components/buttons/AddButton.vue";
import ViewContainer from "@/components/ViewContainer.vue";
import {
  TableComponent,
  TableHead,
  TableRow,
  TableHeadCell,
  TableBody,
  TableCell,
} from "@/components/table";
import PaginationButtons from "@/components/PaginationButtons.vue";
import { Button, ConfirmDialog, Toast } from "primevue";
import ModalPettyCash from "./modals/ModalPettyCash.vue";
import { mapGetters } from "vuex";
import { formatRupiah } from "@/helpers/formatRupiah";
import { formatTime } from "@/helpers/formatTime";
import DetailComponent from "../new-transaction/DetailComponent.vue";

export default {
  name: "PettyCashView",
  components: {
    IndexView, PageTitle, AddButton, ViewContainer, TableComponent, TableHead, TableRow, TableHeadCell, TableBody, TableCell, PaginationButtons, ConfirmDialog, Button, Toast, ModalPettyCash, DetailComponent
  },
  data() {
    return {
      modalShowPettyCash: false,
      isBlur: false,
      selectedPettyCash: null,
      currentPage: 1,
      totalPages: 1,
    }
  },
  computed: {
    ...mapGetters('petty_cash', ['allPettyCashes']),
    ...mapGetters('cash_registers', ['allCashRegisters']),
    filteredPettyCashes() {
      this.allPettyCashes.map(pc => {
        pc.cash_register = this.allCashRegisters.find(cr => cr.id == pc.cash_register_id);
        return pc;
      });
      return this.allPettyCashes;
    },
    openCashRegister() {
      return this.allCashRegisters.find(cr => cr.status == 'open');
    },
    currentTotalAmountCashRegisterOpen() {
      console.log(this.openCashRegister);
      let amountCashRegisterOpen = this.openCashRegister ? this.openCashRegister?.orders.reduce((sum, item) => sum + (item.status == 'paid' ? parseFloat(item.grand_total) : 0), 0) : 0;
      let amountPettyCashOpen = this.openCashRegister ? this.allPettyCashes.reduce((sum, pc) => sum + (this.openCashRegister.id == pc.cash_register_id ? parseFloat(pc.amount_deposit ? pc.amount_deposit : 0) + parseFloat(pc.amount_withdrawal ? pc.amount_withdrawal*(-1) : 0) : 0), 0) : 0;
      return parseFloat(this. openCashRegister ? this.openCashRegister?.start_saldo : 0) + amountCashRegisterOpen + amountPettyCashOpen;
    },
    summaryCashRegister() {
      return [
        { field: 'Total Kas', value: this.currentTotalAmountCashRegisterOpen, type: 'rupiah' }
      ];
    }
  },
  async created() {
    await this.$store.dispatch('petty_cash/fetchPettyCashes');
    await this.$store.dispatch('cash_registers/fetchCashRegisters');
    console.log(this.openCashRegister);
  },
  watch: {
    currentPage: {
      immediate: true,
      handler(newVal) {
        this.fetchPettyCashes({ page: newVal });
      },
    }
  },
  methods: {
    formatRupiah,
    formatTime,
    async fetchPettyCashes(params = {}) {
      if (!params.page) params.page = this.currentPage;
      if (!params.limit) params.limit = 50;
      try {
        const { pagination } = await this.$store.dispatch('petty_cash/fetchPettyCashes', params);
        if (pagination) {
          this.totalPages = pagination.totalPages;
        }
      } catch (error) {
        console.log(error);
      }
      await this.$store.dispatch('cash_registers/fetchCashRegisters');
    },
    showModal() {
      this.modalShowPettyCash = true;
      this.isBlur = true;
      this.selectedPettyCash = null;
    },
    closeModal() {
      setTimeout(() => {
        this.modalShowPettyCash = false;
        this.isBlur = false;
        this.fetchPettyCashes();
      }, 200);
    },
    editPettyCash(petty_cash) {
      this.selectedPettyCash = petty_cash;
      this.modalShowPettyCash = true;
      this.isBlur = true;
    },
    async deletePettyCash(petty_cash) {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menghapus pengeluaran ini?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: async () => {
          try {
            const response = await this.deletePettyCashById(petty_cash.id);
            console.log('response', response);
            this.fetchPettyCashes();
            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Berhasil menghapus pengeluaran.', life: 3000 });
          }
          catch (error) {
            console.error('Gagal menghapus pengeluaran.', error);
            this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Gagal menghapus pengeluaran.', life: 3000 });
          }
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Batal menghapus pengeluaran.', life: 3000 });
        }
      });
    }, 
  },
}
</script>